export default __webpack_public_path__ + "static/media/category_17.af51ae99.png";